import { createPreset } from '@media-ui/pypo-article/src/containers/Article/presets/preset';
import PetsKind from 'Components/KindCrosslink/KindCrosslink';
export const transform = (data: any) => {
    const { url, main_image, name, prepositional_name } = data.data.kind;
    return Object.assign(data, {
        url,
        name,
        main_image,
        prepositional_name,
    });
};
const kindPreset = createPreset({
    type: 'petskind',
})(PetsKind, transform);
export default kindPreset;
